<template>
  <div class="links-picker drgpicker text-noselect">
    <div
      class="gw_box flex-1 f-column mh-0"
      style="--clr-box-back: var(--clr-black-0); --box-padding: 1.25rem 1rem 1.5rem 1rem"
    >
      <slot name="selected_title"></slot>
      <DragDropGrid
        class="drgpicker_selected mt-4"
        :items="l_selected"
        dropTargetIdPart="picker_cell_selected"
        @update:cells="handleDragUpdate"
      >
        <template
          v-for="(item, iIdx) in l_selected"
          #[`cell_${item.id}`]="v"
          :key="`${item.id}_${iIdx}`"
        >
          <div class="drgpicker_item w-100">
            <slot
              name="selected_item"
              :item="item"
              >{{ item.id }}</slot
            >
            <div class="drgpicker_icon_cont">
              <div
                class="drillrow_handle mb-auto"
                @click.stop
              >
                <div
                  class="drgpicker_icon_drag drillrow_handle_normal mdi mdi-drag pa-1 csst csst_nm csst_active-hide-content icon_btn clr-grey"
                  style="--clr-icon-back: var(--clr-black-2)"
                  @mousedown="e => v.dd_events.handleDragstart({ e, item: v.cell })"
                  @touchstart="e => v.dd_events.handleDragstart({ e, item: v.cell })"
                  @mouseenter="e => fl_positionTooltip(e, { placement: 'top' })"
                >
                  <div
                    class="csst_content clr-white text-nowrap clr-white"
                    style="position: fixed"
                    v-html="$t('tooltips.drill_drag_drop_change_order')"
                  ></div>
                </div>
              </div>
              <div
                v-if="canDelete"
                class="mdi mdi-trash-can drgpicker_icon drgpicker_icon_trash clr-error f-center mt-auto icon_btn csst csst_nm"
                @click="removeItem(item)"
                @mouseenter="e => fl_positionTooltip(e, { placement: 'top' })"
              >
                <div
                  class="csst_content text-nowrap clr-white"
                  style="position: fixed"
                  v-html="$t('common.remove')"
                ></div>
              </div>
            </div>
          </div>
        </template>
        <template #shallowitem="{ item }">
          <slot
            name="shallowitem"
            :item="item"
          >
            {{ item ? item.id : '' }}
          </slot>
        </template>
        <template #draggedcell>
          <div
            class="w-100 gw_box z-index_4"
            style="
              --clr-box-back: var(--clr-black-2);
              --box-radius: 4px;
              --box-height: 100%;
              position: absolute;
            "
          ></div>
        </template>
      </DragDropGrid>
      <div
        v-if="!selected.length"
        class="gw_box f-center w-100 clr-grey"
        style="--clr-box-back: var(--clr-black-2)"
        v-html="emptySectedMessage || $t('dashboard_links.empty_selected_message')"
      ></div>
    </div>
    <div class="my-2"></div>
    <div
      class="gw_box flex-1"
      style="--clr-box-back: var(--clr-black-1-3); --box-padding: 1.25rem 1rem 1.5rem 1rem"
    >
      <slot name="notselected_title"></slot>
      <div class="drgpicker_notselected mt-4">
        <div
          v-for="(item, iIdx) in notselected"
          :key="`${item.name}_${iIdx}`"
          class="drgpicker_item"
        >
          <slot
            name="notselected_item"
            :item="item"
            >{{ item.id }}</slot
          >
          <div
            class="drgpicker_icon_cont"
            @click.stop
          >
            <div
              class="mdi mdi-plus drgpicker_icon drgpicker_icon_add f-center icon_btn csst csst_nm"
              @click="addItem(item)"
              @mouseenter="e => fl_positionTooltip(e, { placement: 'top' })"
            >
              <div
                class="csst_content text-nowrap clr-white"
                v-html="$t('common.add')"
              ></div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="!notselected.length"
        class="gw_box f-center w-100 clr-grey"
        style="--clr-box-back: var(--clr-black-2)"
        v-html="emptyNotSectedMessage || $t('dashboard_links.empty_notselected_message')"
      ></div>
    </div>
  </div>
</template>

<script>
import links_mix from '@/mixins/links_mix'
import DragDropGrid from '@/components/DragDropGrid/DragDropGrid'
import float_mix from '@/mixins/float_mix'

export default {
  name: 'DragDropPicker',
  components: {
    DragDropGrid,
  },
  mixins: [links_mix, float_mix],
  props: {
    selected: { default: () => [] },
    options: { default: () => [] },
    emptySectedMessage: { default: '' },
    emptyNotSectedMessage: { default: '' },
    canDelete: { type: Boolean, default: true },
  },
  emits: ['update:selected'],
  data() {
    this.tagLiveStyle = `
        --tag-padding:0 0.25rem;--clr-tag:var(--clr-white-0); --clr-tag-back: var(--clr-error);
        `
    return {
      l_selected: [],
      notselected: [],
    }
  },
  methods: {
    initialize() {
      this.l_selected = [...this.selected]
      this.getNotSelected()
    },
    getNotSelected() {
      this.notselected = this.options.filter(i => !this.l_selected.some(ii => ii.id === i.id))
      // console.log(this.l_selected, this.notselected)
    },
    emitUpdate() {
      this.$emit('update:selected', this.l_selected)
    },
    addItem(item) {
      this.l_selected = [...this.l_selected, item]
      this.getNotSelected()
      this.emitUpdate()
    },
    removeItem(item) {
      this.l_selected = this.l_selected.filter(i => i.id !== item.id)
      this.getNotSelected()
      this.emitUpdate()
    },
    handleDragUpdate(cells) {
      this.l_selected = cells.reduce((a, b) => [...a, b.item], [])
      this.emitUpdate()
    },
  },

  watch: {
    selected: {
      immediate: true,
      handler: 'initialize',
    },
  },
}
</script>
<style lang="scss">
.drgpicker {
  &_texticon {
    line-height: 1;
    padding: 0 0.125rem;
    width: 1rem;
    &_encircled {
      &:before {
        border-radius: 4px;
        background: var(--clr-grey-2);
        color: var(--clr-black-1-3);
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.drgpicker {
  position: relative;
  display: flex;
  flex-direction: column;
  min-height: 0;

  --icon-after-radius: 4px;
  .icon_btn {
    --after-radius: var(--icon-after-radius);
  }

  &_item {
    position: relative;
    display: flex;
  }
  &_icon {
    &_cont {
      --dimendions-icon: 32px;
      position: absolute;
      display: flex;
      justify-content: flex-end;
      flex-direction: column;

      top: calc(-0.15 * var(--dimendions-icon));
      right: calc(-0.15 * var(--dimendions-icon));
      height: calc(calc(0.3 * var(--dimendions-icon)) + 100%);
    }
    --clr-icon-back: var(--clr-black-3);
    font-size: 1.25rem;
    height: var(--dimendions-icon);
    width: var(--dimendions-icon);
    background: var(--clr-icon-back);
    border-radius: 50%;
    &_drag {
      font-size: 1.25rem;
      height: var(--dimendions-icon);
      width: var(--dimendions-icon);
      top: 0.125rem;
      position: relative;
    }
    &_trash {
      font-size: 1.25rem;
      color: var(--clr-error);
    }
    &_add {
      font-size: 1.25rem;
      color: var(--clr-primary);
    }
  }

  --display: grid;
  --grid-gap: 1rem;
  --grid-template-columns: repeat(3, 1fr);
  --grid-template-rows: unset;
  --grid-auto-flow: row;
  &_notselected {
    display: var(--display);
    grid-template-columns: var(--grid-template-columns);
    grid-template-rows: var(--grid-template-rows);
    grid-auto-flow: var(--grid-auto-flow);
    grid-gap: var(--grid-gap);
  }
  &_selected,
  &_notselected {
    max-height: 50%;
    margin: 0 -1rem;
    padding: 0 1rem;
  }
}

@media (max-width: 1023px) {
  .drgpicker {
    --grid-template-columns: unset;
    &_notselected {
      display: flex;
      flex-direction: column;
    }
    &_selected,
    &_notselected {
      max-height: calc(var(--vh-100) * 0.5 - 9.75rem);
      overflow-y: auto;
      overflow-x: hidden;
      min-height: 0;
      padding-top: 0.125rem;
    }
  }
}
</style>
